import { render } from "./CalendarEventOffersList.vue?vue&type=template&id=16c06e82&scoped=true"
import script from "./CalendarEventOffersList.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOffersList.vue?vue&type=script&lang=ts"

import "./CalendarEventOffersList.vue?vue&type=style&index=0&id=16c06e82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16c06e82"

export default script